import { createTheme } from "@material-ui/core/styles";
import styles from "../styles/variables.scss";

export const MenuTheme = createTheme({
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: styles.thirdBackgroundColor,
                marginTop: "8px",
                transform: "translateX(-16px) !important",
                boxShadow: "0 0 0 1px hsla(0,0%, 0%, 0.1)"
            },
            rounded: {
                borderRadius: styles.defaultBorderRadius,
            }
        },
        MuiList: {
            root: {
                background: styles.thirdBackgroundColor,
                color: styles.fontColor,
                fontFamily: "Montserrat, sans-serif",
                borderRadius: styles.defaultBorderRadius,
                boxShadow: "0 0 0 1px hsla(0,0%, 0%, 0.1)"
            }
        },
        MuiListItem: {
            root: {
                color: styles.thirdFontColor,
                fontSize: "12px !important",
                fontFamily: "Montserrat, sans-serif !important",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: "14px",
                paddingRight: "14px"
            },
            button: {
                "& svg": {
                    fill: styles.thirdFontColor,
                    height: "20px",
                    width: "20px",
                    marginRight: "8px"
                },
                "&:hover": {
                    backgroundColor: "unset",
                    color: styles.fontColor,
                    "& svg": {
                        fill: styles.fontColor
                    }
                }
            }
        },
        MuiMenuItem: {
            root: {
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: "14px",
                paddingRight: "14px"
            }
        }
    }
});